export default __webpack_public_path__ + "static/media/tv.0daba667.png";